import Cross from "../../../assets/icon/NewsIcons/MainAdmin/NewsCross"
import React, { useState, useEffect, useRef } from "react";
import { axiosReq } from "../../../commons/axiosReq";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Select from "react-select";
const SettingModal = ({ setShowModal, title, buttonName , setRecheck, reCheck,data}) => {
    let navigate = useNavigate();
    const [snipper, setSnipper] = useState(false);
    const [showErrorModalStep1,
        setShowErrorModalStep1] = useState(false);
        const [selectedOptions, setSelectedOptions] = useState([]);
        const [approvalRequired, setApprovalRequired] = useState("yes"); // حالت پیش‌فرض: "دارد"
    
        const [error, setError] = useState(); // حالت پیش‌فرض: "دارد"

      
    const [allValues, setAllValues] = useState({
      AdminManagement: data?data.adminManagement.toString(): '',
      ArticleManagement: data?data.articleManagement.toString(): '',
      CategoryManagement: data?data.categoryManagement.toString(): '',
      Supervisor: data?data.supervisor.toString(): '',
      AuthorManagement: data?data.authorManagement.toString(): '', 

    });
    const [allValuesError, setAllValuesError] = useState({
      AdminManagement: false,
      AuthorManagement: false,
      ArticleManagement: false,
      CategoryManagement: false,
      Supervisor: false,
      

    });
    const blurHandler = e => {
        if (e.target) {
            if (e.target.value == "") {

                setAllValuesError({ ...allValuesError, [e.target.name]: true })
            }


        }

    }
    const changeHandler = e => {
        if (e.target) {
            if (e.target.value != "") {

                setAllValuesError({ ...allValuesError, [e.target.name]: false })
            }
            else {
                setAllValuesError({ ...allValuesError, [e.target.name]: true })

            }
            // setAllValuesError({ ...allValuesError, [""]: false })


            setAllValues({ ...allValues, [e.target.name]: e.target.value })
        }
    }
    const handleKeyDown = (e) => {
        if (e.code === "Enter") {
          AccessAdmin();
        }
    };
    const handleSelectChange = (selected) => {
        setSelectedOptions(selected || []);
      };
      const handleRadioChange = (e) => {
        console.log(allValues)
          setAllValues({ ...allValues, [e.target.name]: e.target.value });
        };
  
  
    const AccessAdmin = async () => {

        setSnipper(true)
        var res = allFull(allValues)
        console.log(res)
        if (res) {
            const dataUser = await axiosReq("Article/UpdateAdminAccess","put", {
                ID:data?.adminId,
                AdminManagement: allValues?.AdminManagement,
                ArticleManagement: allValues?.ArticleManagement,
                CategoryManagement: allValues?.CategoryManagement,
                Supervisor: allValues?.Supervisor,
            AuthorManagement: allValues?.AuthorManagement,

            });
            console.log(dataUser)
            if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {
                setRecheck(!reCheck)

                //   navigate("/newRequestStep2/" + dataUser?.data?.requestId)
                alert("موفقیت آمیز");
                setShowModal(false)
            }
            else {
                console.log(allValuesError)
                setError(dataUser)
                setShowErrorModalStep1(true);
            }
        }
        else {
            console.log(allValuesError)
            setShowErrorModalStep1(true);

        }
    }
    const allFull = (obj) => {
        const updatedState = {};
        var result = true;
        for (var o in obj) {
            if (obj[o] == "" ) {
                updatedState[o] = true;


                setAllValuesError({ ...allValuesError, ...updatedState })
                result = false;
            }
         

        }
        console.log(allValuesError)
        return result
    }
 
    
    return (
        <>
            <div
                className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
            >
                <div className="relative w-[50%] my-5 mx-auto ">

                    <div className="border-0 rounded-[20px] p-[25px] shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        <div className="flex justify-between items-center border-b-2 pb-[25px] border-borderGray">
                            <p className="text-[15px] font-IRANYekanBold text-mainColor2">{title}</p>
                            <button onClick={() => setShowModal(false)}><Cross /></button>
                        </div>
                        <div className="grid grid-cols-2 gap-2 w-full mt-[23px] mb-[43px]">
                           
                            {/* <div className="col-span-2 mb-[10px] flex flex-col">
                <p className="text-[15px] font-IRANYekanBold text-mainColor2 mb-1">انتخاب دسته بندی برای این نویسنده</p>
                <div className="w-full">
                  <Select
                    options={options}
                    isMulti
                    value={selectedOptions}
                    onChange={handleSelectChange}
                    placeholder="دسته‌ها را انتخاب کنید"
                    styles={customStyles} 
                    className="text-[12px] font-IRANYekanNormal focus:outline-lightGray border-[1px] border-borderGray rounded-[5px]"
                  />
                </div>
              </div> */}
              <div className="col-span-2 mb-[10px] flex flex-col  mt-4">
                <p className="text-[15px] font-IRANYekanBold text-mainColor2 mb-2">
                  امکان تعریف دیگر ادمین ها
                </p>
                <div className="flex items-center space-x-4 space-x-reverse">
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="AdminManagement"
                      value={true}
                      checked={allValues.AdminManagement == "true"}
                      onChange={handleRadioChange}
                      className="w-4 h-4 text-Orange2 border-gray-300 focus:ring-Orange2 ml-2"
                    />
                    <span className="ml-2 text-[14px] font-IRANYekanNormal">دارد</span>
                  </label>
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="AdminManagement"
                      value={false}
                      checked={allValues.AdminManagement === "false"}
                      onChange={handleRadioChange}
                      className="w-4 h-4 text-Orange2 border-gray-300 focus:ring-Orange2 ml-2"
                    />
                    <span className="ml-2 text-[14px] font-IRANYekanNormal">ندارد</span>
                  </label>
                </div>
              </div>
              <div className="col-span-2 mb-[10px] flex flex-col  mt-4">
                <p className="text-[15px] font-IRANYekanBold text-mainColor2 mb-2">
                  امکان تعریف نویسنده های دیگر
                </p>
                <div className="flex items-center space-x-4 space-x-reverse">
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="AuthorManagement"
                      value={true}
                      checked={allValues.AuthorManagement === "true"}
                      onChange={handleRadioChange}
                      className="w-4 h-4 text-Orange2 border-gray-300 focus:ring-Orange2 ml-2"
                    />
                    <span className="ml-2 text-[14px] font-IRANYekanNormal">دارد</span>
                  </label>
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="AuthorManagement"
                      value={false}
                      checked={allValues.AuthorManagement === "false"}
                      onChange={handleRadioChange}
                      className="w-4 h-4 text-Orange2 border-gray-300 focus:ring-Orange2 ml-2"
                    />
                    <span className="ml-2 text-[14px] font-IRANYekanNormal">ندارد</span>
                  </label>
                </div>
              </div>
              <div className="col-span-2 mb-[10px] flex flex-col  mt-4">
                <p className="text-[15px] font-IRANYekanBold text-mainColor2 mb-2">
                  امکان تعریف و ویرایش دسته بندی 
                </p>
                <div className="flex items-center space-x-4 space-x-reverse">
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="CategoryManagement"
                      value={true}
                      checked={allValues.CategoryManagement == "true"}
                      onChange={handleRadioChange}
                      className="w-4 h-4 text-Orange2 border-gray-300 focus:ring-Orange2 ml-2"
                    />
                    <span className="ml-2 text-[14px] font-IRANYekanNormal">دارد</span>
                  </label>
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="CategoryManagement"
                      value={false}
                      checked={allValues.CategoryManagement == "false"}
                      onChange={handleRadioChange}
                      className="w-4 h-4 text-Orange2 border-gray-300 focus:ring-Orange2 ml-2"
                    />
                    <span className="ml-2 text-[14px] font-IRANYekanNormal">ندارد</span>
                  </label>
                </div>
              </div>
              <div className="col-span-2 mb-[10px] flex flex-col  mt-4">
                <p className="text-[15px] font-IRANYekanBold text-mainColor2 mb-2">
                  امکان نظارت
                </p>
                <div className="flex items-center space-x-4 space-x-reverse">
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="Supervisor"
                      value={true}
                      checked={allValues.Supervisor == "true"}
                      onChange={handleRadioChange}
                      className="w-4 h-4 text-Orange2 border-gray-300 focus:ring-Orange2 ml-2"
                    />
                    <span className="ml-2 text-[14px] font-IRANYekanNormal">دارد</span>
                  </label>
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="Supervisor"
                      value={false}
                      checked={allValues.Supervisor == "false"}
                      onChange={handleRadioChange}
                      className="w-4 h-4 text-Orange2 border-gray-300 focus:ring-Orange2 ml-2"
                    />
                    <span className="ml-2 text-[14px] font-IRANYekanNormal">ندارد</span>
                  </label>
                </div>
              </div>
              <div className="col-span-2 mb-[10px] flex flex-col  mt-4">
                <p className="text-[15px] font-IRANYekanBold text-mainColor2 mb-2">
               امکان انتشار و ویرایش خبر
                </p>
                <div className="flex items-center space-x-4 space-x-reverse">
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="ArticleManagement"
                      value={true}
                      checked={allValues.ArticleManagement == "true"}
                      onChange={handleRadioChange}
                      className="w-4 h-4 text-Orange2 border-gray-300 focus:ring-Orange2 ml-2"
                    />
                    <span className="ml-2 text-[14px] font-IRANYekanNormal">دارد</span>
                  </label>
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="ArticleManagement"
                      value={false}
                      checked={allValues.ArticleManagement == "false"}
                      onChange={handleRadioChange}
                      className="w-4 h-4 text-Orange2 border-gray-300 focus:ring-Orange2 ml-2"
                    />
                    <span className="ml-2 text-[14px] font-IRANYekanNormal">ندارد</span>
                  </label>
                </div>
              </div>

                        </div>
                        <div className="flex justify-center">
                            <button onClick={() => setShowModal(false)}><p className="text-[15px] font-IRANYekanBold ml-[23px]">بستن</p></button>
                            <button onClick={()=>AccessAdmin()} className="h-[40px] w-[107px] bg-infinity-gradient rounded-[10px]"><p className="text-[15px] text-white font-IRANYekanBold">{buttonName}</p></button>
                        </div>
                    </div>
                </div>
                {showErrorModalStep1 ?
                    <>
                        <div
                            className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
                        >
                            <div className="relative w-[50%] lg:w-[50%] sm:w-[95%] my-5 mx-auto max-w-3xl">

                                <div className="border-0 rounded-lg p-2 shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">

                                    <div className="flex items-start justify-between p-4 border-b border-solid border-b-midGray rounded-t">
                                        <span className="text-base font-bold   text-red">
                                            درخواست اشتباه !
                                        </span>

                                    </div>

                                    <div className="relative px-4 py-1 flex-auto">
                                        <p className="my-4 text-black text-sm   leading-relaxed">
                                           {error}
                                        </p>
                                    </div>

                                    <div className="flex  items-center  justify-end border-solid border-slate-200 rounded-b">
                                        <Link

                                            className="text-white  mx-4 mb-2  rounded-md shadow-blueShadow   bg-infinity-gradient font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none ease-linear transition-all duration-150"
                                            type="button"
                                            onClick={() => setShowErrorModalStep1(false)}
                                        >
                                            فهمیدم
                                        </Link>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>

                    </>
                    : null
                }
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
    )
}

export default SettingModal;